<!-- jb-switch = 'jb-btn' -->

<h2>{{name}}</h2>
<hr/>
<p>{{desc}}</p>
<p>
  This is an On / Off component that handles a boolean model (true / false).
  <br>There is an input checkbox under the hood, but styled as a switch with 2 positions.
</p>

<h5 class="mt-4">Parameters:</h5>
<div class="col-12"><pre>{{api}}</pre></div>


<div class="whiteBg">
  <div class="row">
    <div class="col-5 marB15">
      <h5 class="marB25">Switch Customization:</h5>
      <div class="row">
        <jb-input class="col-4" [hidden]="!swConf.hasFormFit" [class.flat]="swConf.hasFlat"
                  [jbLabel]="swConf.hasLabel ? 'Test' : undefined" [(ngModel)]="myValue2">
        </jb-input>
        <jb-switch [(ngModel)]="myValue" class="col-4"
                   [class.form-fit]="swConf.hasFormFit"
                   [class.flat]="swConf.hasFlat"
                   [jbLabel]="(swConf.hasLabel ? swConf.labelText : '')"
                   [jbLabelPos]="(swConf.labelPosLeft ? 'left' : 'top')"
                   [jbOnText]="(swConf.hasOnText ? swConf.onText : 'scripts.common.directives.on_label')"
                   [jbOffText]="(swConf.hasOffText ? swConf.offText : 'scripts.common.directives.off_label')"
                   [jbTooltip]="(swConf.hasTooltip ? swConf.btnTooltip : null)"
                   [jbTooltipPos]="(swConf.btnTooltipPos || 'top')"
                   [jbTooltipBody]="swConf.btnTooltipBody"
                   [jbDisabled]="swConf.isDisabled">
        </jb-switch>
      </div>
      <div class="padT30">
        <div class="code-box pad15">
          <pre>{{swCode}}</pre>
        </div>
      </div>
    </div>

    <div class="col-7">
      <div class="row marT15">
        <div class="col-2 padT5"> <jb-checkbox [(ngModel)]="swConf.isDisabled" (ngModelChange)="updateCustomSw()" jbLabel="Is Disabled"></jb-checkbox> </div>
<!--        <div class="col-10">-->
<!--          <jb-input class="flat" [(ngModel)]="swConf.btnDisabledTip" jbPlaceholder="This button is disabled because..." (ngModelChange)="updateCustomSw()"></jb-input>-->
<!--        </div>-->
      </div>

      <div class="row marT15">
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="swConf.hasLabel" (ngModelChange)="updateCustomSw()" jbLabel="Has Label"></jb-checkbox> </div>
        <div class="col-6" style="margin-bottom: -5px;"> <jb-input [(ngModel)]="swConf.labelText" (ngModelChange)="updateCustomSw()" [jbDisabled]="!swConf.hasLabel"></jb-input> </div>
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="swConf.labelPosLeft" [jbDisabled]="!swConf.hasLabel" (ngModelChange)="updateCustomSw()" jbLabel="Label On Left"></jb-checkbox> </div>
        <div class="col-3"></div>
        <div class="col-9">
          <div class="row marT10">
            <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="swConf.hasTooltip" [jbDisabled]="!swConf.hasLabel" (ngModelChange)="updateCustomSw()" jbLabel="Has Tooltip"></jb-checkbox> </div>
            <div class="col-8" *ngIf="swConf.hasTooltip">
              <jb-input [(ngModel)]="swConf.btnTooltip" (ngModelChange)="updateCustomSw()"></jb-input>
            </div>
            <div class="col-3" *ngIf="swConf.hasTooltip"></div>
            <div class="col-4" *ngIf="swConf.hasTooltip">
              jbTooltipPos: <jb-dropdown [(ngModel)]="swConf.btnTooltipPos" (ngModelChange)="updateCustomSw()" [jbList]="swTooltipPos" jbRender="text" jbSelect="id"> </jb-dropdown>
            </div>
            <div class="col-4" *ngIf="swConf.hasTooltip">
              jbTooltipBody: <jb-dropdown [(ngModel)]="swConf.btnTooltipBody" (ngModelChange)="updateCustomSw()" [jbList]="swTooltipBody" jbRender="text" jbSelect="id"> </jb-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="row marT20">
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="swConf.hasOnText" (ngModelChange)="updateCustomSw()" jbLabel="Custom 'ON' Text"></jb-checkbox> </div>
        <div class="col-6" style="margin-bottom: -5px;"> <jb-input [(ngModel)]="swConf.onText" (ngModelChange)="updateCustomSw()" [jbDisabled]="!swConf.hasOnText"></jb-input> </div>
      </div>
      <div class="row">
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="swConf.hasOffText" (ngModelChange)="updateCustomSw()" jbLabel="Custom 'OFF' Text"></jb-checkbox> </div>
        <div class="col-6" style="margin-bottom: -5px;"> <jb-input [(ngModel)]="swConf.offText" (ngModelChange)="updateCustomSw()" [jbDisabled]="!swConf.hasOffText"></jb-input> </div>
      </div>
      <div class="row">
        <div class="col-3">CSS Classes:</div>
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="swConf.hasFormFit" (ngModelChange)="updateCustomSw()" jbLabel="form-fit" jbTooltip="Adds margin top and bottom to align it into a form line"></jb-checkbox> </div>
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="swConf.hasFlat" (ngModelChange)="updateCustomSw()" jbLabel="flat" [hidden]="!swConf.hasFormFit"></jb-checkbox> </div>
      </div>


      </div>

  </div>
</div>

<hr>



<!--Examples-->
<h5 class="mt-4">Examples:</h5>
<div class="col-12 examples-table">
  
  <div class="row">
    <div class="col-2">
      <jb-switch [(ngModel)]="myVal"></jb-switch>
    </div>
    <div class="col-1">
      <span (click)="myVal=!myVal">myVal={{myVal}}</span>
    </div>
    <div class="col-9"> <pre>{{instance}}</pre> </div>
  </div>

  <div class="row">
    <div class="col-3">
      <jb-switch [(ngModel)]="myVal" [jbDisabled]="true"></jb-switch>
    </div>
    <div class="col-9"> <pre>{{instance2}}</pre> </div>
  </div>

  <div class="row">
    <div class="col-3">
      <jb-switch [(ngModel)]="myVal"
                 jbLabel="view.common.name" jbLabelPos="left">
      </jb-switch>
    </div>
    <div class="col-9"> <pre>{{instance3}}</pre> </div>
  </div>

  <div class="row">
    <div class="col-3">
      <jb-switch [(ngModel)]="myVal"
                 jbLabel="view.common.name">
      </jb-switch>
    </div>
    <div class="col-9"> <pre>{{instance4}}</pre> </div>
  </div>

</div>


<!--CSS Styling-->
<div class="row marT40">
  <div class="col-12">
    <hr>
    <h4>CSS Styling</h4>
    <p>The styles of the switch are not encapsulated. You can use the following variables to restyle the global defaults:</p>
    <pre>{{ cssReset }}</pre>
    <p>Or define custom colors for a particular instance applying:</p>
    <pre>{{ cssReset2 }}</pre>
  </div>
</div>
